import { render, staticRenderFns } from "./PurchaseOrderItemTaxManager.vue?vue&type=template&id=260127de&scoped=true"
import script from "./PurchaseOrderItemTaxManager.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderItemTaxManager.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderItemTaxManager.vue?vue&type=style&index=0&id=260127de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260127de",
  null
  
)

export default component.exports